export type CreateRootComponentRequest = {
  godFlg: string;
  dipByRgn: string;
  rootCpntId: string;
  rootCpntName: string;
  ownTypeCd: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  alctnTypeCd: string;
  clodSrvcTypeCd: string;
  rgnTypeCd: string;
  acntName: string;
  notSysUsg: string;
  rootCpntIchrList: RootCpntIchr[];
  cpntId: string;
  cpntNameWtngChng: string;
  cpntDesc: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
};
export type RootCpntIchr = {
  index: number;
  ichrId?: string;
  ichrName?: string;
  pstnName?: string;
  cmpnyName?: string;
  telNum?: string;
  mlAdrs?: string;
};
export type EdhPrtcl = {
  inOutTypeCd?: string;
  edhPrtclTypeCd?: string;
};
export type IfStrtMthd = {
  ifStrtMthdTypeCd?: string;
};
export type EdhNtfctnType = {
  inOutTypeCd?: string;
  edhNtfctnTypeCd?: string;
};
